import service from '../../utils/request'


const getCoupon = (data) => {
    return service({
        url: `api/personal/coponSrc?aid=${data}`,
        method: 'GET',
        data
    })
}
const getCouponList = (data) => {
    return service({
        url: `api/personal/getCouponList`,
        method: 'POST',
        data
    })
}

const pullCopon = (data) => {
    return service({
        url: 'api/personal/getCoupon',
        method: 'POST',
        data
    })
}

export {
    getCoupon,
    pullCopon,
    getCouponList
}